module.exports = __webpack_public_path__ + "img/background-fl-detail.472448d3.svg";